/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps*/
import React, { useState, useEffect } from "react";
import { Row, Col, UncontrolledTooltip } from "reactstrap";
import { withTranslation } from "react-i18next";

// Redux
import { useSelector } from "react-redux";

//Components that mount the header: filters, search-area, search-buttons and etc
import TableHeaderFilter from "./sub/TableHeaderFilter/index";
import TableHeaderDropdown from "./sub/TableHeaderDropdown/index";

//Imports of the three status icon's
import ellipseSuccess from "../../../../../../../../../../assets/images/manager-area/ellipse-success.svg";
import ellipseWarning from "../../../../../../../../../../assets/images/manager-area/ellipse-warning.svg";
import ellipseDanger from "../../../../../../../../../../assets/images/manager-area/ellipse-danger.svg";

import ManagerPanelIcons from "../../../../../../../../components/Common/ManagerPanelIcons.js";

//The only component that can be componentized into these <thead>, the buttons
import AgentsTableHeadButton from "./sub/AgentsTableHeadButtons/index";

import "./TableHeaderFilter.scss";
import "../../../../../../common.scss";

const index = ({
  onExpand,
  handleRefresh,
  loadingData,
  onlineFilterClicked,
  backsoonFilterClicked,
  offlineFilterClicked,
  onlineAgentsQtd,
  backsoonAgentsQtd,
  offlineAgentsQtd,
  searchFilterValueReceived,
  filterInputValue,
  onCardButtonClick,
  onListButtonClick,
  showMode,
  t,
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  const { loadingAgent } = useSelector(
    (state) => state.Manager
  );

  const [isOnline, setIsOnline] = useState(true);
  const [isOffline, setIsOffline] = useState(true);
  const [isBacksoon, setIsBacksoon] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleSecondContainer = (e) => {
    setIsExpanded(!e);
    onExpand(!e);
  };

  const toggleOnlineFilter = () => setIsOnline(!isOnline);

  const toggleBacksoonFilter = () => setIsBacksoon(!isBacksoon);

  const toggleOfflineFilter = () => setIsOffline(!isOffline);

  useEffect(() => {
    onlineFilterClicked(isOnline);
  }, [isOnline]);

  useEffect(() => {
    offlineFilterClicked(isOffline);
  }, [isOffline]);

  useEffect(() => {
    backsoonFilterClicked(isBacksoon);
  }, [isBacksoon]);

  return (
    <Row className="mt-3">
      <Col>
        <div
          id="agents-table-filter-area"
          className="d-flex flex-wrap justify-content-between"
        >
          <span className={`section-title ${mainTheme} mb-2 mr-4 `}>
            {t("Agents")}
          </span>

          <section className="d-flex justify-content-start table-filters-area mb-2">
            <div id="online-filter-area">
              <TableHeaderFilter
                id="filter"
                statusPath={ellipseSuccess}
                onClick={() => toggleOnlineFilter()}
                clickProp="online"
                quantity={onlineAgentsQtd}
                isActive={isOnline}
                filterOnlineItemText="online"
              />
              <UncontrolledTooltip
                className="agent-status-tooltip"
                placement="top"
                target="filter"
              >
                {`${t("When selected, will display agents with status")} `}
                <u>online</u>
                {`. ${t("A second click removes the selection.")}`}
              </UncontrolledTooltip>
            </div>

            <div id="backsoon-filter-area">
              <TableHeaderFilter
                id="backsoon"
                statusPath={ellipseWarning}
                onClick={() => toggleBacksoonFilter()}
                clickProp="inativo"
                quantity={backsoonAgentsQtd}
                isActive={isBacksoon}
                filterBacksoonItemText="backsoon"
              />
              <UncontrolledTooltip
                className="agent-status-tooltip"
                placement="top"
                target="backsoon"
              >
                {`${t("When selected, will display agents with status")} `}
                <u>{t("backsoon")}</u>
                {`. ${t("A second click removes the selection.")}`}
              </UncontrolledTooltip>
            </div>

            <div id="offline-filter-area">
              <TableHeaderFilter
                id="offline"
                statusPath={ellipseDanger}
                onClick={() => toggleOfflineFilter()}
                clickProp="offline"
                quantity={offlineAgentsQtd}
                isActive={isOffline}
                filterOfflineItemText="offline"
              />
              <UncontrolledTooltip
                className="agent-status-tooltip"
                placement="top"
                target="offline"
              >
                {`${t("When selected, will display agents with status")} `}
                <u>{t("away")}</u>
                {`. ${t("A second click removes the selection.")}`}
              </UncontrolledTooltip>
            </div>
          </section>

          <section className="d-flex table-selectors-area mb-2">
            <TableHeaderDropdown
              optionDefault={t("All agents")}
              searchFilterValueReceived={searchFilterValueReceived}
              filterInputValue={filterInputValue}
            />
            <button
              className={`conversation-header-button-wrapper ${
                mainTheme === "dark" ? "dark" : "light bg-primary"
              } mx-2`}
              onClick={() => handleRefresh()}
              disabled={loadingAgent}
            >
              <i
                className={`bx bx-refresh bx-xs mr-0 align-self-center header-button-icons header-button-refresh ${
                  loadingData ? "loading-spinning" : ""
                }`}
              ></i>
            </button>
            <button
              className="table-header-button-wrapper mx-3"
              onClick={() => {
                toggleSecondContainer(isExpanded);
              }}
            >
              {isExpanded ? (
                <ManagerPanelIcons
                  className="table-header-button"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  cx="20"
                  cy="20"
                  r="20"
                  fill={"none"}
                  fillcolor={mainTheme === "light" ? "#556ee6" : "#202533"}
                  d="M0 0H16V16H0z"
                  transform="translate(12 12)"
                  done="M5 14h6v6M3 21l6.1-6.1M20 10h-6V4M21 3l-6.1 6.1"
                  transformone="translate(5 5) translate(3 3)"
                />
              ) : (
                <ManagerPanelIcons
                  className="table-header-button"
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  cx="20"
                  cy="20"
                  r="20"
                  fill={"none"}
                  fillcolor={mainTheme === "light" ? "#556ee6" : "#202533"}
                  d="M0 0H16V16H0z"
                  transform="translate(12 12)"
                  done="M10.01 0L6.16 3.85M3.85 6.16L0 10.01M5.39 0L10.01 0 10.01 4.62"
                  transformone="translate(12 12) translate(3 3)"
                  dtwo="M0 5.39L0 10.01 4.62 10.01"
                  transformtwo="translate(12 12) translate(3 3)"
                />
              )}
            </button>

            {/* <button className="table-header-button-wrapper mx-3">
              <img
                className="table-header-button"
                src={moreOptionsIcon}
                alt="more-options-icon"
              />
            </button> */}
          </section>

          <section className="d-flex justify-content-end ml-auto mb-2">
            <AgentsTableHeadButton
              classname="agents-visualization-btn"
              isActive={showMode.cardMode ? true : false}
              isDark={mainTheme === "dark" ? true : false}
              icon="group-view-ico"
              onClick={onCardButtonClick}
            />
            <AgentsTableHeadButton
              classname="agents-visualization-btn"
              isActive={showMode.listMode ? true : false}
              isDark={mainTheme === "dark" ? true : false}
              icon="list-view-ico"
              onClick={onListButtonClick}
            />
          </section>
        </div>

        <hr />
      </Col>
    </Row>
  );
};

export default withTranslation()(index);
